import { Vehicle } from '../../../../types/vehicle';
import { useDispatch, useSelector } from 'react-redux';
import { modalsToggle, pullVehicle } from '../../../../actions';
import { openRelistDialog } from '../../../../services/auctionVehicles/auctionVehiclesSlice';
import { ModalWrapper } from 'components';

type Props = {
  vehicle: Vehicle;
};

const PatchedModalWrapper = ModalWrapper as any;

export const PullVehicleModal = ({ vehicle }: Props) => {
  const dispatch = useDispatch();

  const { shouldRelistAfterPull } = useSelector((state: any) => state.auctionVehicles);

  const handlePull = () => {
    dispatch(pullVehicle({ vehicle_id: vehicle.id }).request);
    dispatch(modalsToggle(`confirm-pull-${vehicle.id}`));
    if (shouldRelistAfterPull) {
      dispatch(openRelistDialog(vehicle.id));
    }
  };

  const handleRelist = () => {
    dispatch(openRelistDialog(vehicle.id));
  };

  return (
    <PatchedModalWrapper
      title={'Are you sure you want to pull this vehicle from the auction?'}
      handleSubmit={handlePull}
      modalId={`confirm-pull-${vehicle.id}`}
      submitText={'Pull'}
      cancelPosition="left"
      showNew
      newText={'Relist'}
      handlePressNew={handleRelist}
    />
  );
};
